import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { redirectToAccountPage } from 'common/utilities/utils';
import { useSelector } from 'react-redux';
import ValidateCard from '../presentation/ValidateCard';
import { dispatchGlobalPaymentCardVerification } from 'organisms/Payment/utils/GlobalPaymentUtils';
const ValidateCardContainer = params => {
  const { location } = params;
  const { props = '' } = location;
  const { checkoutDetails, updateCheckoutDetails } = props;
  const [retryCountForGetOrderStatus, setretryCountForGetOrderStatus] = useState({ orderStatus: 1 });
  const history = useHistory();
  const { paymentsReducer } = useSelector(data => data);

  const updateSaveCardDetails = useCallback(param => {
    setretryCountForGetOrderStatus && setretryCountForGetOrderStatus(prevState => ({ ...prevState, ...param }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    updateSaveCardDetails({
      orderStatus: retryCountForGetOrderStatus.orderStatus + 1,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentsReducer?.globalPaymentsGeneratedAccessToken]);

  useEffect(() => {
    checkoutDetails?.globalPaymentsOneTimeResponse?.paymentReference &&
      dispatchGlobalPaymentCardVerification({ checkoutDetails, updateCheckoutDetails, history });
    updateSaveCardDetails({
      orderStatus: retryCountForGetOrderStatus.orderStatus + 1,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkoutDetails?.globalPaymentsOneTimeResponse?.paymentReference]);

  useEffect(() => {
    checkoutDetails?.globalPaymentValidateAdressResponse &&
      updateSaveCardDetails({
        orderStatus: retryCountForGetOrderStatus.orderStatus + 1,
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentsReducer?.globalPaymentValidateAdressResponse]);

  useEffect(() => {

    updateSaveCardDetails({
      orderStatus: retryCountForGetOrderStatus.orderStatus + 1,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentsReducer?.globalPaymentVerifyCard]);

  useEffect(() => {
    paymentsReducer?.globalPaymentSaveCard && redirectToAccountPage({ ...history });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentsReducer?.globalPaymentSaveCard]);

  return (
    <>
      <ValidateCard retryCountForGetOrderStatus={retryCountForGetOrderStatus} />
    </>
  );
};
export default ValidateCardContainer;
